export const DASHBOARD = "/";
export const VIEW_NOTICES = "/view-notices";
/** A sent Notice's page; it opens on the Notice passed as router state `{ notice }`. */
export const noticeHref = (noticeId: string | undefined) => `/notice/${noticeId}`;
export const CREATE_NOTICE = "/create-notice";
/** Calendar; it opens on a day, or with Add event filled in, from router state (see calendarHandover). */
export const CALENDAR = "/calendar";
export const NOVA = "/nova";
/** Planners (behind the `planner` flag): the list, a new one, and one Planner. */
export const PLANNERS = `${CALENDAR}/planners`;
export const NEW_PLANNER = `${PLANNERS}/new`;
export const plannerHref = (plannerId: string) =>
  `${PLANNERS}/${encodeURIComponent(plannerId)}`;
export const USER_MANAGEMENT = "/user-management";
export const MANAGE_USERS = "/manage-users";

export const userHomeHref = (userId: string) =>
  `${USER_MANAGEMENT}/${encodeURIComponent(userId)}`;
/** Circles, and one Circle's page; it starts adding a User from router state (see circleHandover). */
export const CIRCLES = "/circles";
export const circleHref = (circleId: string) => `${CIRCLES}/${encodeURIComponent(circleId)}`;
export const TEAM_MANAGEMENT = "/team-management";
export const PROFILE = "/profile";
export const KNOWLEDGE_BASE = "/knowledge-base";

/** Library's worksheets, a grade's, or one kind for a grade ("grade-r", "counting"). */
export const WORKSHEETS = "/create/worksheets";
export const worksheetsHref = (gradeKey?: string, activity?: string) =>
  [WORKSHEETS, gradeKey, gradeKey && activity].filter(Boolean).join("/");
/** Library's Resources: Sunday School stories and printable books. */
export const RESOURCES = "/resources";

export const SIGNATURES = `${CREATE_NOTICE}/signatures`;
/** A birthday card, sent to a circle as an image notice. */
export const NEW_BIRTHDAY = `${CREATE_NOTICE}/celebrations/new`;

/** A notice Template's own page; the Templates themselves are listed on Create Notice. */
export const NOTICE_TEMPLATES = `${CREATE_NOTICE}/templates`;
export const NEW_NOTICE_TEMPLATE = `${NOTICE_TEMPLATES}/new`;
export const noticeTemplateHref = (templateId: string) =>
  `${NOTICE_TEMPLATES}/${encodeURIComponent(templateId)}`;

export const CERTIFICATES = `${CREATE_NOTICE}/certificates`;
export const CERTIFICATE_TEMPLATES = `${CERTIFICATES}/templates`;
export const NEW_CERTIFICATE_TEMPLATE = `${CERTIFICATE_TEMPLATES}/new`;
export const AWARDS = `${CERTIFICATES}/awards`;
export const NEW_AWARD = `${AWARDS}/new`;
/** A saved Award's tabs: its Awardees (where it opens) and the Award's own details. */
export type AwardTab = "awardees" | "award";
export const awardHref = (awardId: string, tab: AwardTab = "awardees") =>
  `${AWARDS}/${encodeURIComponent(awardId)}${tab === "award" ? "/award" : ""}`;
/** The tab in an Award's address; anything unknown opens on Awardees. */
export const awardTabFromAddress = (segment: string | undefined): AwardTab =>
  segment === "award" ? "award" : "awardees";
export const certificateTemplateHref = (certificateTemplateId: string) =>
  `${CERTIFICATE_TEMPLATES}/${encodeURIComponent(certificateTemplateId)}`;
